import { PlusOutlined } from '@ant-design/icons';
import { queryRolePageList } from '@api/roleManagement';
import ZeissButton from '@components/button';
import { DicListHook } from '@hooks/useDicListHook';
import { roleList } from '@store';
import type { TabsProps } from 'antd';
import { Tabs } from 'antd';
import { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { useImmer } from 'use-immer';
import { AdminPopup } from './Popup/admin';
import { RoleSalesPopup } from './Popup/sales';
import { useRoleAdmin } from './hooks/RoleManagement/Admin/useRoleAdmin';
import { useRoleSales } from './hooks/RoleManagement/Sales/useRoleSales';
import { useRoleSector } from './hooks/RoleManagement/Sector/useRoleSector';
import './index.scss';
interface RecordData {
  remark: string;
  roleId: number;
  roleKey: string;
  roleName: string;
}
const RoleManagementList = () => {
  const [open, setOpen] = useState(false); // Admin & Sector 弹框
  const [salesOpen, setSalesOpen] = useState(false); // Sales 弹框
  const [currentTabKey, setCurrentTabKey] = useState('Admin'); //选择的Tab页Key
  const [roleIdList, setRoleIdList] = useRecoilState(roleList); //Admin / Sector / Sales 的 roleId ，roleKey 和 rowName
  const [refreshTable, setRefreshTable] = useState(0);
  const { data: dicList } = DicListHook(); //Sector 选择框中的值
  const [refreshSaleTable, setRefreshSaleTable] = useState(0);
  const { roleAdminComponent } = useRoleAdmin({ roleIdList, refreshTable });
  const { roleSalesComponent } = useRoleSales({
    roleIdList,
    refreshSaleTable,
    dicList
  });
  const { roleSectorComponent } = useRoleSector({
    roleIdList,
    refreshTable,
    dicList
  });
  const [tabList, setTabList] = useImmer<string[]>([]); //Tab权限 Admin / Sector / Sales

  const items: TabsProps['items'] = [
    {
      key: 'Admin',
      label: 'Admin',
      children: roleAdminComponent
    },
    {
      key: 'Sector',
      label: 'Sector',
      children: roleSectorComponent
    },
    {
      key: 'Sales',
      label: 'Sales',
      children: roleSalesComponent
    }
  ];

  const onChange = (key: string) => {
    setCurrentTabKey(key);
  };

  const queryRolePage = async () => {
    const res = await queryRolePageList({
      pageSize: 10,
      pageNumber: 1
    });
    const recordList = (res?.rolesPage.records || []).map(
      (x: RecordData) => x.roleName
    );
    let tempRoleId = {};
    //获取每一个Tab页的roleId组成对象
    (res?.rolesPage.records || []).forEach((x: RecordData) => {
      tempRoleId = {
        ...tempRoleId,
        [x.roleName]: {
          roleId: x.roleId,
          roleKey: x.roleKey,
          roleName: x.roleName
        }
      };
    });
    //Admin || Sector || Sales Tab页 是否渲染
    const isAdminExist = recordList.includes('Admin');
    setCurrentTabKey(isAdminExist ? 'Admin' : 'Sector');
    setTabList(recordList);
    setRoleIdList(tempRoleId);
  };

  //新增
  const handleCreateAccount = () => {
    if (currentTabKey === 'Sales') {
      setSalesOpen(true);
    } else {
      setOpen(true);
    }
  };

  // Admin & Sector 表格刷新
  const refreshTableList = () => {
    setRefreshTable(refreshTable + 1);
  };

  // Sales表格刷新
  const refreshSaleTableList = () => {
    setRefreshSaleTable(refreshSaleTable + 1);
  };

  useEffect(() => {
    queryRolePage();
  }, []);

  return (
    <>
      <Tabs
        defaultActiveKey="Sector"
        items={items.filter((x: { key: string }) =>
          (tabList || []).includes(x.key)
        )}
        onChange={onChange}
        tabBarExtraContent={
          <div>
            <ZeissButton
              type="primary"
              onClick={handleCreateAccount}
              icon={<PlusOutlined />}
            >
              新增
            </ZeissButton>
          </div>
        }
      />
      <RoleSalesPopup
        open={salesOpen}
        dicList={dicList}
        record={{}}
        setOpen={setSalesOpen}
        currentTabKey={currentTabKey}
        getDataSource={refreshSaleTableList}
      />
      <AdminPopup
        open={open}
        record={{}}
        dicList={dicList}
        setOpen={setOpen}
        currentTabKey={currentTabKey}
        getDataSource={refreshTableList}
      />
    </>
  );
};
export default RoleManagementList;
